import WarrantyClaimPanelComponent from "./warrantyClaimPanel.container";

export default WarrantyClaimPanelComponent;
